import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from "../../config";

// The server answers identically whether or not the address is registered, so
// this page must too. Showing "no account with that email" here would turn the
// endpoint into a way to test addresses one at a time against the customer
// list -- which is exactly what the generic response exists to prevent.

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            await fetch(`${API_BASE_URL}/api/auth/password-reset/request`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
        } catch {
            /* Deliberately ignored: a network error must not become the signal
               that distinguishes a real address from a made-up one. */
        }
        setSent(true);
        setSubmitting(false);
    }

    if (sent) {
        return (
            <div className="wb-page wb-page--narrow">
                <h1>Check your email</h1>
                <p className="wb-sub">
                    If an account exists for <strong>{email}</strong>, a reset link is on its
                    way. It works once and expires in an hour.
                </p>
                <Link to="/login" className="wb-btn wb-btn--secondary">Back to sign in</Link>
            </div>
        );
    }

    return (
        <div className="wb-page wb-page--narrow">
            <h1>Reset your password</h1>
            <p className="wb-sub" style={{ marginBottom: '1.5rem' }}>
                Enter the email address on your account and we will send you a link.
            </p>

            <form onSubmit={handleSubmit} className="wb-card">
                <label className="wb-field">
                    <span className="wb-label">Email</span>
                    <input
                        className="wb-input" type="email" autoComplete="email" required autoFocus
                        value={email} onChange={(e) => setEmail(e.target.value)}
                    />
                </label>
                <button
                    type="submit"
                    className="wb-btn wb-btn--primary wb-btn--block"
                    disabled={submitting}
                >
                    {submitting ? 'Sending…' : 'Send reset link'}
                </button>
            </form>

            <p className="wb-sub" style={{ marginTop: '1.5rem' }}>
                <Link to="/login">Back to sign in</Link>
            </p>
        </div>
    );
}
